angular.module('picmonicng').directive('authorTile', [
  function () {
    return {
      restrict: 'E',
      template:
        '<div class="author-tile directive" ng-class="{pointer: card.author.id !== 1}"><profile-picture user="card.author"></profile-picture> <span class="author-name" browse-sref="{{card.author.id === 1 ? \'\' : \'app.search\'}}" browse-sref-params="{onlyPicmonics: true, q:\'{{card.author.username}}\'}">{{card.author.username}}</span><i ng-if="card.entity_type_id == 2 && card.card_id >= 50000" class="picmonic-icons md-16 profile-picture m-l-1 pls-orange">verified_creator</i></div>',
      scope: {
        card: '=',
      },
    };
  },
]);
